import { useQuery } from '@tanstack/react-query';

import type { FacilityScreenerSettingsEntry } from '@/types/crm-screener-api';

import { SCREENER_SETTINGS_PER_FACILITY_KEY } from './useFacilityScreenerSettings';

type ScreenerSettingValue = string | number | object;

function useFacilityScreenerSettingsEntry(
  facilityId: string
): FacilityScreenerSettingsEntry | undefined {
  const { data } = useQuery<FacilityScreenerSettingsEntry | undefined>({
    queryKey: [SCREENER_SETTINGS_PER_FACILITY_KEY, facilityId],
    queryFn: () => undefined,
    enabled: false
  });

  return data;
}

export function useScreenerSetting<T extends ScreenerSettingValue = string>(
  settingName: string,
  facilityId: string
): T | undefined {
  return useFacilityScreenerSettingsEntry(facilityId)?.settings?.[
    settingName
  ] as T | undefined;
}

export function useIsScreenerSettingEnabled(
  settingName: string,
  facilityId: string
): boolean {
  return useScreenerSetting<string>(settingName, facilityId) === 'enabled';
}

export function useSingleFacilityScreenerSettings(
  facilityId: string
): FacilityScreenerSettingsEntry | undefined {
  return useFacilityScreenerSettingsEntry(facilityId);
}
